const sliders = {
    init () {
        const Flickity = require('flickity');

        var flkty = new Flickity( '.testimonials-slider-init', {
            // options
            watchCSS: true,
            wrapAround: true,
            prevNextButtons: false,
            // freeScroll: true,
            initialIndex: 2,
            imagesLoaded: true,
        });
        // watchCSS: true

    }
}

export {sliders}